/* Product information tabs: Bootstrap 5.0.2 manual keyboard activation. */
(function () {
  'use strict';
  if (window.__fbpProductTabsA11y) return;
  window.__fbpProductTabsA11y = true;

  function initialize(section) {
    var list = section.querySelector('[data-fbp-product-tablist]');
    if (!list || list.dataset.fbpTabsReady) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"][data-bs-toggle="tab"]'));
    var pairs = tabs.map(function (tab) {
      var id = tab.getAttribute('aria-controls');
      var panels = Array.prototype.filter.call(section.querySelectorAll('.tab-pane'), function (panel) { return panel.id === id; });
      return panels.length === 1 ? { tab: tab, panel: panels[0] } : null;
    });
    // Do not bind keyboard controls to missing or ambiguous panels.
    if (!pairs.length || pairs.some(function (pair) { return !pair; })) return;
    list.dataset.fbpTabsReady = 'true';

    function enabledTabs() {
      return tabs.filter(function (tab) { return !tab.disabled && !tab.classList.contains('disabled') && tab.getAttribute('aria-disabled') !== 'true' && !tab.hidden; });
    }
    function setStop(tab) {
      tabs.forEach(function (entry) { entry.tabIndex = entry === tab ? 0 : -1; });
    }
    function selectedTab() {
      return enabledTabs().find(function (tab) { return tab.classList.contains('active'); });
    }
    function keepFocusedTabVisible() {
      var tab = document.activeElement;
      if (tabs.indexOf(tab) < 0) return;
      var rect = tab.getBoundingClientRect();
      var top = 8;
      var header = document.querySelector('header.header');
      if (header) {
        var headerRect = header.getBoundingClientRect();
        if (headerRect.bottom > 0 && headerRect.top < window.innerHeight / 2) {
          top = Math.max(top, headerRect.bottom + 8);
        }
      }
      var bottom = window.innerHeight - 8;
      var delta = rect.top < top ? rect.top - top : rect.bottom > bottom ? rect.bottom - bottom : 0;
      // Only reveal a focused tab when obscured; never recenter the page.
      if (Math.abs(delta) > 0.5) window.scrollBy({ top: delta, behavior: 'instant' });
    }
    function scheduleVisibility() {
      window.requestAnimationFrame(keepFocusedTabVisible);
    }
    function synchronize() {
      var selected = selectedTab();
      pairs.forEach(function (pair) {
        pair.tab.setAttribute('aria-selected', pair.tab === selected ? 'true' : 'false');
      });
      setStop(selected || enabledTabs()[0]);
      scheduleVisibility();
    }
    var selected = selectedTab() || enabledTabs()[0];
    pairs.forEach(function (pair) {
      pair.tab.classList.toggle('active', pair.tab === selected);
      pair.panel.classList.toggle('active', pair.tab === selected);
      pair.tab.setAttribute('aria-selected', pair.tab === selected ? 'true' : 'false');
    });
    setStop(selected);

    list.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      var current = event.target.closest('[role="tab"]');
      if (!current || current.parentElement.closest('[data-fbp-product-tablist]') !== list) return;
      var items = enabledTabs();
      var index = items.indexOf(current);
      if (index < 0) return;
      var next;
      var vertical = list.getAttribute('aria-orientation') === 'vertical';
      var rtl = getComputedStyle(list).direction === 'rtl';
      if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = items.length - 1;
      else if (vertical && event.key === 'ArrowDown') next = index + 1;
      else if (vertical && event.key === 'ArrowUp') next = index - 1;
      else if (!vertical && event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
      else if (!vertical && event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
      else return; // Native Enter/Space activates Bootstrap; perpendicular arrows scroll.
      event.preventDefault();
      next = (next + items.length) % items.length;
      setStop(items[next]);
      items[next].focus({ preventScroll: true });
      scheduleVisibility();
    });
    list.addEventListener('focusin', scheduleVisibility);
    list.addEventListener('focusout', function (event) {
      if (!list.contains(event.relatedTarget)) setStop(selectedTab() || enabledTabs()[0]);
    });
    list.addEventListener('shown.bs.tab', synchronize);
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-fbp-product-tabs]')) initialize(scope);
    scope.querySelectorAll('[data-fbp-product-tabs]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
